import type { Table } from "@tanstack/react-table";

import type { DataTableFilter } from "./types";

/**
 * Filtros por columna, de lista.
 *
 * Son `select` nativos y no un desplegable propio: uno nativo ya trae
 * teclado, lector de pantalla y, en móvil, el selector del sistema operativo,
 * que es mejor que cualquier cosa que se pinte aquí.
 *
 * Solo de lista, nada de texto libre por columna: competiría con la búsqueda
 * global y habría dos sitios donde escribir lo mismo.
 */
export function DataTableFilters<TData>({
  table,
  filters,
}: {
  table: Table<TData>;
  filters: DataTableFilter[];
}) {
  if (filters.length === 0) return null;

  return (
    <>
      {filters.map((filtro) => {
        const column = table.getColumn(filtro.columnId);
        if (!column) return null;
        const valor = (column.getFilterValue() as string | undefined) ?? "";

        return (
          <label key={filtro.columnId} className="flex items-center gap-1.5 text-xs text-slate-500">
            {filtro.label}
            <select
              value={valor}
              onChange={(e) => column.setFilterValue(e.target.value === "" ? undefined : e.target.value)}
              className="rounded-lg border border-white/15 bg-white/[0.04] px-2 py-1 text-xs text-slate-200 transition focus:border-sky-400/60 focus:outline-none [&>option]:bg-[#11162a]"
            >
              <option value="">todos</option>
              {filtro.options.map((opcion) => (
                <option key={opcion.value} value={opcion.value}>
                  {opcion.label}
                </option>
              ))}
            </select>
          </label>
        );
      })}
    </>
  );
}
